import * as React from 'react';
import { UAParser } from 'ua-parser-js';

export const useUserAgent = () => {
  const [agentInfo] = React.useState(() => {
    const uaParser = new UAParser();
    return uaParser.getResult();
  });

  // check for iOS (including simulators)
  const isIos = agentInfo.os.name === 'iOS';
  const isMobileSafari = agentInfo.browser.name === 'Mobile Safari';

  // Push notifications are possible with PWAs on iOS 16.4 or later.
  const isIosPushNotificationsSupported = isIos;
  agentInfo.os.version &&
    +agentInfo.os.version.split('.')[0] >= 16 &&
    +agentInfo.os.version.split('.')[1] >= 4;

  // check for iPads
  const isIpad = agentInfo.device.model === 'iPad';

  // check for android devices
  const isAndroid = agentInfo.os.name === 'Android';
  const isMobile = isIos || isAndroid || isIpad;

  return {
    agentInfo,
    isIos,
    isIpad,
    isAndroid,
    isMobile,
    isIosPushNotificationsSupported,
    isMobileSafari
  };
};
